
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import MainLayout from "../layout/UserLayout";
import AdminLayout from "../layout/AdminLayout";
import OrganisationRegistrationForm from "../pages/OrganisationRegistrationForm";
import OrganizationPayment from "../pages/OrganizationPayment";
import CreateEvent from "../pages/CreateEvent";
import EventViewPayPage from "../pages/EventViewPayPage";
import OrgApprovalPage from "../admin/OrganiztionApprovalPage";
import EventApprovalPage from "../admin/EventApprovalPage";
import { routes } from './routes-names';

import PaymentSuccess from '../payment/paymentsuccess';
import PaymentFailure from '../payment/paymentfailure';
import  LoginPage from '../pages/LoginPage';
import  UserWelcome from '../pages/UserWelcome';
import AdminWelcome from '../admin/AdminWelcome';
import AdminLogin from '../admin/AdminLogin';

import CameraCapture from '../pages/CameraCapture';
import DoctorApprovalPage from '../admin/DoctorApprovalPage';
import DoctorRegPrint from '../admin/DoctorRegPrint';
import OrgPrintCertificate from '../pages/OrgPrintCertificate';
import EventDoctorsInfoPage from '../pages/EventDoctorsInfoPage';
import CPDCertificatePrint from "../admin/CPDCertificatePrint";
import DailyPhotoCapture from "../pages/DailyPhotoCapture";
import ResetPassword from "../forgotpassword/ResetPassword";
import UpcomingEvents from "../pages/UpcomingEvents";
import OrganisationEditForm from "../pages/OrganisationEditForm";
import EditEvent from "../pages/EditEvent";
import UpcomingEventsForm from '../admin/UpcomingEventsForm';
import FailedEmails from "../admin/FailedEmails";


const isDelegate = () =>
  !!sessionStorage.getItem("ATTENDANCE_TOKEN");

const MainRoute = () => {

	return (
		

		<BrowserRouter>
      <Routes>
        

				<Route path={routes.paymentsuccess} element={<PaymentSuccess />} />
				<Route path={routes.payment_failure} element={<PaymentFailure />} />
        {/* <Route path={routes.index}  element={<LoginPage />} /> */}
        <Route path={routes.index} element={ isDelegate() ? <Navigate to={routes.capture_photo} replace /> : <LoginPage /> } />
        <Route path={routes.admin_login}  element={<AdminLogin />} />
        <Route path="/" element={<Navigate to="/index" />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/upcoming-events" element={<UpcomingEvents />} />
        
        
        <Route path={routes.userLayout} element={<MainLayout />}>
              <Route index element={<UserWelcome />} />
              <Route path={routes.orgReg} element={<OrganisationRegistrationForm />} />
              <Route path={routes.orgRegpayment} element={<OrganizationPayment />} />
              <Route path={routes.OrgPrint} element={<OrgPrintCertificate />} />
              <Route path={routes.eventReg} element={<CreateEvent />} />
              <Route path={routes.eventViewEdit}  element={<EventViewPayPage />} />
                {/*<Route path={routes.capture_photo} element={<BlinkCapture />} />*/}
               <Route path={routes.capture_photo} element={<CameraCapture />} />
               <Route path="/mainLayout/daily-capture-photo" element={<DailyPhotoCapture />} />
               <Route path={routes.eventDocInfo}  element={<EventDoctorsInfoPage />}  />
               <Route path="/mainLayout/edit-organization" element={<OrganisationEditForm />} />
               <Route path="/mainLayout/edit-event/:eventId" element={<EditEvent />} />
               
                
          
        </Route>

              <Route  path={routes.adminLayout} element={<AdminLayout />}>
               <Route index element={<AdminWelcome />} />
                <Route path={routes.admin_Org_approvals} element={<OrgApprovalPage />} />
                <Route path={routes.admin_Event_approvals} element={<EventApprovalPage/>} />
                <Route path={routes.admin_doctor_approvals} element={<DoctorApprovalPage/>} />
                <Route path={routes.admin_docPrint} element={<DoctorRegPrint />} />
                <Route path={routes.admin_CpdCertPrint}  element={<CPDCertificatePrint />} />
                <Route path={routes.admin_failed_emails} element={<FailedEmails />} />
                <Route path="admin-settings" element={<h2>Settings Page</h2>} />
                <Route path={routes.admin_upcoming_form} element={<UpcomingEventsForm />} />
                </Route>

      </Routes>
    </BrowserRouter>
	);
};

export default MainRoute;
